module.exports = __webpack_public_path__ + "static/media/Quam-Icon-DocumentPen.4c9264c3.svg";